/**
 * Logger centralise - evite les console.log/error en production
 * En dev : affiche dans la console
 * En prod : silencieux (ou envoyer a Sentry plus tard)
 */

const isDev = import.meta.env.DEV;

export const logger = {
  error: (...args: unknown[]) => {
    if (isDev) {
      console.error("[ERROR]", ...args);
    }
    // TODO: En prod, envoyer a Sentry
    // if (import.meta.env.PROD) Sentry.captureException(args[0]);
  },

  warn: (...args: unknown[]) => {
    if (isDev) {
      console.warn("[WARN]", ...args);
    }
  },

  log: (...args: unknown[]) => {
    if (isDev) {
      console.log("[LOG]", ...args);
    }
  },

  debug: (...args: unknown[]) => {
    if (isDev) {
      console.debug("[DEBUG]", ...args);
    }
  },
};
